import {
  ArrowLeftRight,
  Award,
  BadgeCheck,
  Building2,
  CirclePause,
  Fingerprint,
  FlaskConical,
  Layers,
  Link,
  ListChecks,
  MessagesSquare,
  RefreshCw,
  Rocket,
  ShieldCheck,
  Shuffle,
  Sparkles,
  Wrench,
  type LucideIcon,
} from 'lucide-react';
import s from '../site.module.css';

/**
 * Lucide icons for the public pages. Decoration only: each sits beside words that already say the same thing, so it
 * is hidden from assistive technology. The lists follow the content modules' card order.
 */
export const ICONS = {
  /** client.capabilities.cards */
  capabilities: [Shuffle, Fingerprint, Link, Layers, ArrowLeftRight, Rocket, Sparkles],
  /** client.heldRecords.steps */
  heldSteps: [CirclePause, Wrench, RefreshCw],
  /** reps.whatYouGet.cards */
  whatYouGet: [MessagesSquare, FlaskConical],
  /** reps.demoStudio.cards */
  demoStudio: [Building2, Wrench, ListChecks, Rocket],
  /** client.portal.proof, all but the closing sentence */
  proof: [Award, BadgeCheck],
  data: ShieldCheck,
} satisfies Record<string, LucideIcon | LucideIcon[]>;

/** An icon in a tinted badge; the tint alternates orange and sky with the card it sits on. */
export function IconBadge({ icon: Icon }: { icon?: LucideIcon }) {
  if (!Icon) return null;
  return (
    <span className={s.iconBadge}>
      <Icon size={22} strokeWidth={2} aria-hidden="true" focusable="false" />
    </span>
  );
}

/** An inline icon before a line of text. */
export function InlineIcon({ icon: Icon }: { icon?: LucideIcon }) {
  if (!Icon) return null;
  return <Icon className={s.inlineIcon} size={18} strokeWidth={2.25} aria-hidden="true" focusable="false" />;
}
